const subNavigationCls = "_61sntv15y";
const pillsWrapper = "_61pv9oi16";

export { pillsWrapper, subNavigationCls };
import "./sub-navigation.style.linaria.module.css";
//# sourceMappingURL=sub-navigation.style.js.map
